import { $api } from '../services';

export default function(store) {
  store.$api = $api
}